import { defineMessages, FormattedMessage } from 'react-intl';

import { commonMessages } from '@/messages/common';

export const messages = defineMessages({
  haveAnAccount: {
    id: `account.login.title`,
    defaultMessage: 'I already have an account',
  },
  dontHaveAnAccount: {
    id: `checkout.account.register.title`,
    defaultMessage: "I don't have an account",
  },
  checkoutAsGuest: {
    id: `checkout.account.register.cta`,
    defaultMessage: 'Check out as guest',
  },
  signUpBenefitsIntro: {
    id: 'account.signUp.benefits.intro',
    defaultMessage:
      'Everything about your watch in one place. Sign-up for your My Account to access the benefits below:',
  },
  signUpBenefitWarranty: {
    id: 'account.signUp.benefits.warranty',
    defaultMessage: 'Complimentary warranty extension',
  },
  signUpBenefitDocumented: {
    id: 'account.signUp.benefits.documented',
    defaultMessage: 'Your timepieces, fully documented',
  },
  signUpBenefitPassport: {
    id: 'account.signUp.benefits.passport',
    defaultMessage: 'Claim your blockchain-based digital passport',
  },
  signUpBenefitWishlist: {
    id: 'account.signUp.benefits.wishlist',
    defaultMessage: 'Your personal wishlist',
  },
  signUpBenefitHistory: {
    id: 'account.signUp.benefits.history',
    defaultMessage: 'Order, returns and service history',
  },
  signUpBenefitDetails: {
    id: 'account.signUp.benefits.details',
    defaultMessage: 'Manage your details',
  },
});

export const DontHaveAccountDescription = (
  <FormattedMessage
    defaultMessage='Orders can be placed without setting up an account. You will be able to set up an account later if you wish.'
    id='checkout.account.register.description'
  />
);

export const CheckoutAsGuest = (
  <FormattedMessage {...messages.checkoutAsGuest} />
);

export const LogIn = <FormattedMessage {...commonMessages.logIn} />;

export const CreateMyAccount = (
  <FormattedMessage
    defaultMessage='Create my account'
    id='checkout.account.register.createAccount'
  />
);

export const ForgotPassword = (
  <FormattedMessage
    defaultMessage='I forgot my password'
    id='account.login.forgotPassword'
  />
);
